<template lang="pug">
    el-dialog(:title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="90%" :visible.sync="visible" :append-to-body="true" :modal-append-to-body="false" @close="dalogClose")
      el-form(:model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit" label-suffix=":" label-width="100px")
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px;") {{!dataForm.id ? "新增轮播图" : "修改轮播图"}}
          div
            el-form-item(label="类型" prop="type")
              el-select.sel_width_ct(v-model="dataForm.type" placeholder="请选择轮播图类型" clearable)
                el-option(v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.type" @click.native="handleChange(item.type)")
            el-form-item(v-if="dataForm.type === '0'" label="公众号链接" prop="url")
              el-input.width_ct(v-model="dataForm.url" placeholder="例：https://mp.weixin.qq.com/s/123456789"  )
            el-form-item(v-if="dataForm.type === '4'" label="Appid" prop="miniAppId")
              el-input.width_ct(v-model="dataForm.miniAppId" placeholder="请输入小程序Appid")
            el-form-item(v-if="dataForm.type === '4'" label="Path路径" prop="miniPath")
              el-input.width_ct(v-model="dataForm.miniPath" placeholder="不填默认为 pages/index/index")
            el-form-item(label="标题" prop="title1")
              el-input.width_ct(v-model="dataForm.title1" placeholder="请填写轮播图标题"  )
            el-form-item(label="主办方" prop="orgId")
              el-select.sel_width_ct(v-model="dataForm.orgId" placeholder="请选择主办方" filterable clearable)
                el-option(v-for="(item, index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
            el-form-item(label="轮播图" prop="headImg")
              el-input(v-model="dataForm.headImg" v-show="false")
              div.imgbox(style="width: 280px; height: 200px; margin-top: 12px;")
                img(v-if="imageUrl" :src="imageUrl" @click="openImgdailog" style="width: 100%;")
                i(v-else class="el-icon-plus avatar-uploader-icon" @click="openImgdailog")
              imgupload(v-if="openImg" ref="upimg" :width="750" :height="528" @uploadSuccess="doneup")
              //- el-upload(:http-request="uploadSectionFile" action="useless" :headers="headers" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
              //-   img(v-if="imageUrl" :src="imageUrl" class="avatar")
              //-   i(v-else class="el-icon-plus avatar-uploader-icon")
        el-dialog(title="选择" class="el-dialog-custom" :visible.sync="addVisible" width="90%" top="5vh" :append-to-body="true" :modal-append-to-body="false" @close="addVisibleClose")
            //- 增加切换TAB状态栏
            el-tabs(v-model="activeName" @tab-click="handleClick" :before-leave="beforeLeave")
              el-tab-pane(label="竞赛" name="1" :disabled="activeName !== '1'")
                div
                  el-card(shadow="never")
                    div(slot="header")
                        el-input(v-model="matchSearchParams.matchId" style="width: 20%; margin-right: 10px;" placeholder="请输入比赛ID" clearable)
                        el-input(v-model="matchSearchParams.matchName" style="width: 20%; margin-right: 10px;" placeholder="请输入比赛名称" clearable)
                        el-select(v-model="matchSearchParams.userGroupId" style="width: 20%; margin-right: 10px;" placeholder="请选择主办方" filterable clearable)
                          el-option(v-for="(item, index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
                        el-date-picker(v-model="matchSearchParams.__matchTimeRangeArray__" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 20%; margin-right: 10px;")
                        el-button(@click="currentChangeHandle_news(1)" icon="el-icon-search") 查询
                        el-button(@click="_queryCompetitionOfCarousel_reset" icon="el-icon-refresh-right") 重置
                    el-table(:data="leftData" border @selection-change="checkAll" v-if="leftData.length > 0" )
                        el-table-column(type="selection" align="center")
                        el-table-column(prop="matchId" label="比赛ID" align="center" width="160")
                        el-table-column(prop="matchName" label="比赛名称" align="center")
                        el-table-column(prop="orgName" label="主办方" align="center")
                        el-table-column(prop="ctType" header-align="center" align="center" label="比赛类型" width="80")
                            template(slot-scope="scope")
                                font(v-if="scope.row.ctType === 1") 常规赛
                                font(v-if="scope.row.ctType === 2") 月度赛
                                font(v-if="scope.row.ctType === 3") 季度赛
                                font(v-if="scope.row.ctType === 4") 年度总决赛
                        el-table-column(prop="applySize" header-align="center" align="center" label="签位" width="60")
                            template(slot-scope="scope")
                                span() {{ scope.row.joinCount }}/{{ scope.row.applySize }}
                        el-table-column(prop="level" header-align="center" align="center" label="比赛级别" width="100")
                        el-table-column(prop="matchStartTime" header-align="center" align="center" label="比赛时间" width="140")
                        el-table-column(prop="refereeName" header-align="center" align="center" label="裁判" :show-overflow-tooltip="true" width="80")
                            template(slot-scope="scope")
                                font {{ scope.row.refereeName || "-" }}
                        el-table-column(prop="matchStatus" header-align="center" align="center" label="状态" width="100")
                            template(slot-scope="scope")
                                font(v-if="scope.row.matchStatus === 1" )
                                  span.danger()
                                  span() &nbsp; 未审核
                                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()>new Date().getTime()")
                                  span.success()
                                  span() &nbsp; 已发布
                                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount<scope.row.applySize")
                                  span.warning()
                                  span() &nbsp; 报名中
                                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==1")
                                  span.warning()
                                  span() &nbsp; 报满可替
                                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime()<=new Date().getTime() && new Date().getTime()<=new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount>=scope.row.applySize && scope.row.bench==0")
                                  span.warning()
                                  span() &nbsp; 已报满
                                font(v-if="scope.row.matchStatus === 2 && new Date().getTime()>new Date(scope.row.matchSignEndTime).getTime() &&  new Date().getTime()<new Date(scope.row.matchStartTime).getTime()")
                                  span.warning()
                                  span() &nbsp; 报名结束
                                font(v-if="scope.row.matchStatus === 2 &&  new Date().getTime()>new Date(scope.row.matchStartTime).getTime()")
                                  span.warning()
                                  span() &nbsp; 已开赛
                                font(v-if="scope.row.matchStatus === 3")
                                  span.warning()
                                  span() &nbsp; 已取消
                                font(v-if="scope.row.matchStatus === 4")
                                  span.warning()
                                  span() &nbsp; 已结束
                                font(v-if="scope.row.matchStatus === 5")
                                  span.warning()
                                  span() &nbsp; 已拒绝
                        el-table-column(prop="recommend" header-align="center" align="center" label="首页推荐" width="80")
                            template(slot-scope="scope")
                                font(v-if="scope.row.recommend == 0") 未推荐
                                font(v-if="scope.row.recommend == 1") 已推荐
                    el-pagination(@size-change="sizeChangeHandle_news" @current-change="currentChangeHandle_news" :current-page="pageIndex_news" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize_news" :total="totalPage_news" layout="total, sizes, prev, pager, next, jumper")
              el-tab-pane(label="培训" name="2" :disabled="activeName !== '2'")
                div
                  el-card(shadow="never")
                    div(slot="header")
                        el-input(v-model="trainSearchParams.trainCode" style="width: 20%; margin-right: 10px;" placeholder="请输入培训ID" clearable)
                        el-input(v-model="trainSearchParams.name" style="width: 20%; margin-right: 10px;" placeholder="请输入培训名称" clearable)
                        el-select(v-model="trainSearchParams.orgId" style="width: 20%; margin-right: 10px;" placeholder="请选择主办方" filterable clearable)
                          el-option(v-for="(item, index) in sysOrgList" :key="index" :label="item.name" :value="item.orgId")
                        el-date-picker(v-model="trainSearchParams.__trainTimeRangeArray__" type="daterange" value-format="timestamp" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 20%; margin-right: 10px;")
                        el-button(@click="currentChangeHandle_news(1)" icon="el-icon-search") 查询
                        el-button(@click="_queryTrainListOfCarousel_reset" icon="el-icon-refresh-right") 重置
                    el-table(:data="leftData" border  @selection-change="checkAll" max-height="450" v-if="leftData.length > 0")
                        el-table-column(type="selection" align="center")
                        el-table-column(prop="trainCode" header-align="center" align="center" label="培训ID")
                        el-table-column(prop="name" header-align="center" align="center" label="培训名称")
                        el-table-column(prop="orgName" header-align="center" align="center" label="主办方")
                        el-table-column(prop="classCount" header-align="center" align="center" label="班级人数" width="80")
                            template(slot-scope="scope")
                                span() {{ scope.row.joinCount }}/{{ scope.row.classCount }}
                        el-table-column(prop="level" header-align="center" align="center" label="培训级别" width="80")
                        el-table-column(prop="trainStrDate" header-align="center" align="center" label="培训开始时间" width="100")
                        el-table-column(prop="placesName" header-align="center" align="center" label="培训场馆")
                        el-table-column(prop="coachName" header-align="center" align="center" label="教练" :show-overflow-tooltip="true" width="80")
                            template(slot-scope="scope")
                                font {{ scope.row.coachName || "-" }}
                        el-table-column(prop="state" header-align="center" align="center" label="状态" width="100")
                            template(slot-scope="scope")
                                font(v-if="scope.row.state === 1")
                                  span.danger()
                                  span() &nbsp; 未审核
                                font(v-if="scope.row.state === 2")
                                  span.warning()
                                  span() &nbsp; 已拒绝
                                font(v-if="scope.row.state === 3")
                                  span.success()
                                  span() &nbsp; 已发布
                                font(v-if="scope.row.state === 4")
                                  span.warning()
                                  span() &nbsp; 报名中
                                font(v-if="scope.row.state === 5")
                                  span.warning()
                                  span() &nbsp; 报名结束
                                font(v-if="scope.row.state === 6" )
                                  span.warning()
                                  span() &nbsp; 已开训
                                font(v-if="scope.row.state === 7")
                                  span.warning()
                                  span() &nbsp; 已结束
                                font(v-if="scope.row.state === 8")
                                  span.warning()
                                  span() &nbsp; 已取消
                        el-table-column(prop="recommend" header-align="center" align="center" label="首页推荐" width="80")
                            template(slot-scope="scope")
                                font(v-if="scope.row.recommend == 0") 未推荐
                                font(v-if="scope.row.recommend == 1") 已推荐
                    el-pagination(@size-change="sizeChangeHandle_news" @current-change="currentChangeHandle_news" :current-page="pageIndex_news" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize_news" :total="totalPage_news" layout="total, sizes, prev, pager, next, jumper")
              el-tab-pane(label="资讯" name="3" :disabled="activeName !== '3'")
                div
                  el-card(shadow="never")
                    div(slot="header")
                        el-input(v-model="newSearchParams.title" style="width: 20%; margin-right: 10px;" placeholder="请输入资讯标题" clearable)
                        el-select(v-model="newSearchParams.type" style="width: 20%; margin-right: 10px;" placeholder="请选择资讯类型" clearable)
                          el-option(v-for="(item, index) in newTypeList" :key="index" :label="item.name" :value="item.id")
                        el-date-picker(v-model="newSearchParams.__newTimeRangeArray__" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 20%; margin-right: 10px;")
                        el-button(@click="currentChangeHandle_news(1)" icon="el-icon-search") 查询
                        el-button(@click="getLeftData_reset" icon="el-icon-refresh-right") 重置
                    el-table(:data="leftData" border @selection-change="checkAll" max-height="450" v-if="leftData.length > 0")
                        el-table-column(type="selection" header-align="center" align="center")
                        el-table-column(prop="title" header-align="center" align="center" label="标题")
                        el-table-column(prop="type" header-align="center" align="center" label="资讯类型" width="80")
                          template(slot-scope="scope")
                              font(v-if="scope.row.type === 1") 培训
                              font(v-if="scope.row.type === 2") 竞赛
                              font(v-if="scope.row.type === 3") 活动
                              font(v-if="scope.row.type === 4") 图片直播
                        el-table-column(prop="orgName" header-align="center" align="center" label="主办方")
                        el-table-column(prop="publishTime" header-align="center" align="center" label="发布日期" width="100")
                          template(slot-scope="scope")
                              font {{scope.row.publishTime?scope.row.publishTime.split(" ")[0]:""}}
                        el-table-column(prop="summary" header-align="center" align="center" label="摘要")
                          template(slot-scope="scope")
                              span(:title="scope.row.summary") {{ scope.row.summary | ellipsis }}
                        el-table-column(prop="status" header-align="center" align="center" label="状态" width="80")
                          template(slot-scope="scope")
                              font(v-if="scope.row.status === 1") 新建
                              font(v-if="scope.row.status === 2") 已发布
                              font(v-if="scope.row.status === 3") 已撤回
                        el-table-column(prop="isTop" header-align="center" align="center" label="置顶" width="60")
                          template(slot-scope="scope")
                              font(v-if="scope.row.isTop === 1") 是
                              font(v-if="scope.row.isTop === 2") 否
                    el-pagination(@size-change="sizeChangeHandle_news" @current-change="currentChangeHandle_news" :current-page="pageIndex_news" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize_news" :total="totalPage_news" layout="total, sizes, prev, pager, next, jumper")
            span.dialog-footer(slot="footer")
                el-button(@click="checkNews" type="primary") 确 定
                el-button(@click="handleCancel(1)") 取 消
      span.dialog-footer(slot="footer")
        el-button(@click="handleCancel(2)") 取消
        el-button(v-if="dataForm.id" type="primary" @click="dataFormSubmit") 保存修改
        el-button(v-else type="primary" @click="dataFormSubmit") 确定
</template>

<script>
// import util from '@/libs/util.js'

export default {
  data () {
    return {
      visible: false,
      sysOrgList: [],
      placeholder: '请选择',
      activeName: '3',
      previousActiveName: '3',
      typeList: [
        { name: '公众号', type: '0' },
        { name: '竞赛', type: '1' },
        { name: '培训', type: '2' },
        { name: '资讯', type: '3' },
        { name: '小程序', type: '4' }
      ],
      newTypeList: [
        { id: '1', name: '培训' },
        { id: '2', name: '竞赛' },
        { id: '3', name: '活动' },
        { id: '4', name: '图片直播' }
      ],
      imageUrl: '',
      newsId: '', //资讯id
      dataForm: {
        id: '',
        title1: '',
        orgId: '',
        headImg: '',
        url: '',
        type: '',
        miniAppId: '',
        miniPath: '',
      },
      dataRule: {
        type: [{ required: true, message: '请选择轮播图类型！', trigger: 'change' }],
        title1: [{ required: true, message: '资讯标题不能为空！', trigger: 'change' }, { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'change' }],
        url: [{ required: true, message: '公众号链接不能为空！', trigger: 'blur' }],
        miniAppId: [{ required: true, message: 'Appid不能为空！', trigger: 'blur' }],
        orgId: [{ required: true, message: '主办方不能为空！', trigger: 'change' }]
      },
      addVisible: false,
      leftData: [],
      pageIndex_news: 1,
      pageSize_news: 10,
      totalPage_news: 0,
      matchSearchParams: {
        matchId: '',
        matchName: '',
        userGroupId: '',
        __matchTimeRangeArray__: null,
        ctStrTime: '',
        ctEndTime: ''
      },
      trainSearchParams: {
        trainCode: '',
        name: '',
        orgId: '',
        __trainTimeRangeArray__: null,
        applyStrTime: '',
        applyEndTime: ''
      },
      newSearchParams: {
        title: '',
        type: '',
        __newTimeRangeArray__: null,
        strDate: '',
        endDate: ''
      },
      checkedItem: [],
      openImg: '', //剪裁图片组件
    }
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 30) {
        return value.slice(0, 30) + '...'
      }
      return value
    }
  },
  methods: {
    handleClick (tab, event) {},
    beforeLeave (activeName) {
      if (this.checkedItem.length >= 1) {
        this.$message.error('您已经勾选了一条数据')
        return false
      }
      this.activeName = activeName
      this.pageIndex_news = 1
      this.handleSamePost()
      return true
    },
    handleSamePost () {
      if (this.activeName == '1') {
        this._queryCompetitionOfCarousel()
      }
      if (this.activeName == '2') {
        this._queryTrainListOfCarousel()
      }
      if (this.activeName == '3') {
        this.getLeftData()
      }
    },
    handleCancel (par) {
      if (par == 1) {
        this.addVisible = false
      } else {
        this.visible = false
      }
      this.checkedItem = []
    },
    //处理选择链接触发的事件
    handleChange (e) {
      this.activeName = e
      if (this.activeName === '0' || this.activeName === '4') {
        this.checkedItem = []
      } else {
        this.checkedItem = []
        this.checktable()
      }
    },
    init (id) {
      this.dataForm.id = id || ''
      this.imageUrl = ''
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
        params: this.$http.adornParams(),
      })
      .then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
      .then(() => {
        this.$nextTick(() => {
          this.visible = true
          if (this.$refs['dataForm']) {
            this.$refs['dataForm'].resetFields()
          }
        })
      })
      .then(() => {
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/pbRotary/getId/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams(),
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.type = data.bean.type + ''
              this.dataForm.url = data.bean.url
              this.dataForm.title1 = data.bean.title
              this.dataForm.orgId = data.bean.orgId
              this.dataForm.headImg = data.bean.img
              this.dataForm.miniAppId = data.bean.miniAppId || ''
              this.dataForm.miniPath = data.bean.miniPath || ''
              if (data.bean.imgUrl != '' && data.bean.imgUrl != null) {
                this.imageUrl = data.bean.imgUrl
              }
            }
          })
        }
      })
    },
    addVisibleClose () {
      this.leftData = []
      this.matchSearchParams = {
        matchId: '',
        matchName: '',
        userGroupId: '',
        __matchTimeRangeArray__: null,
        ctStrTime: '',
        ctEndTime: ''
      }
      this.trainSearchParams = {
        trainCode: '',
        name: '',
        orgId: '',
        __trainTimeRangeArray__: null,
        applyStrTime: '',
        applyEndTime: ''
      }
      this.newSearchParams = {
        title: '',
        type: '',
        __newTimeRangeArray__: null,
        strDate: '',
        endDate: ''
      }
    },
    //获取赛事信息数据
    _queryCompetitionOfCarousel () {
      if (this.matchSearchParams.__matchTimeRangeArray__ && this.matchSearchParams.__matchTimeRangeArray__.length > 0) {
        this.matchSearchParams.ctStrTime = this.matchSearchParams.__matchTimeRangeArray__[0]
        this.matchSearchParams.ctEndTime = this.matchSearchParams.__matchTimeRangeArray__[1]
      } else {
        this.matchSearchParams.ctStrTime = ''
        this.matchSearchParams.ctEndTime = ''
      }
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/queryCompetitionOfCarousel`),
        method: 'post',
        data: {
          page: this.pageIndex_news,
          rows: this.pageSize_news,
          ...this.matchSearchParams
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.rows
          this.totalPage_news = data.page.total
        } else {
          this.leftData = []
          this.totalPage_news = 0
        }
      })
    },
    _queryCompetitionOfCarousel_reset () {
      this.matchSearchParams = {
        matchId: '',
        matchName: '',
        userGroupId: '',
        __matchTimeRangeArray__: null,
        ctStrTime: '',
        ctEndTime: ''
      }
      this.pageIndex_news = 1
      this._queryCompetitionOfCarousel()
    },
    //获取培训信息数据
    _queryTrainListOfCarousel () {
      if (this.trainSearchParams.__trainTimeRangeArray__ && this.trainSearchParams.__trainTimeRangeArray__.length > 0) {
        this.trainSearchParams.applyStrTime = this.trainSearchParams.__trainTimeRangeArray__[0]
        this.trainSearchParams.applyEndTime = this.trainSearchParams.__trainTimeRangeArray__[1]
      } else {
        this.trainSearchParams.applyStrTime = ''
        this.trainSearchParams.applyEndTime = ''
      }
      this.$http({
        url: this.$http.adornUrl(`/pxTrain/queryTrainListOfCarousel`),
        method: 'post',
        data: {
          page: this.pageIndex_news,
          limit: this.pageSize_news,
          ...this.trainSearchParams
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.$nextTick(() => {
            this.leftData = data.page.records
            this.totalPage_news = data.page.total
          })
        } else {
          this.leftData = []
          this.totalPage_news = 0
        }
      })
    },
    _queryTrainListOfCarousel_reset () {
      this.trainSearchParams = {
        trainCode: '',
        name: '',
        orgId: '',
        __trainTimeRangeArray__: null,
        applyStrTime: '',
        applyEndTime: ''
      }
      this.pageIndex_news = 1
      this._queryTrainListOfCarousel()
    },
    //获取资讯信息数据
    getLeftData () {
      if (this.newSearchParams.__newTimeRangeArray__ && this.newSearchParams.__newTimeRangeArray__.length > 0) {
        this.newSearchParams.strDate = this.newSearchParams.__newTimeRangeArray__[0]
        this.newSearchParams.endDate = this.newSearchParams.__newTimeRangeArray__[1]
      } else {
        this.newSearchParams.strDate = ''
        this.newSearchParams.endDate = ''
      }
      this.$http({
        url: this.$http.adornUrl(`/pbNews/list`),
        method: 'post',
        data: {
          page: this.pageIndex_news,
          limit: this.pageSize_news,
          ...this.newSearchParams,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.totalPage_news = data.page.total
        } else {
          this.leftData = []
          this.totalPage_news = 0
        }
      })
    },
    getLeftData_reset () {
      this.newSearchParams = {
        title: '',
        type: '',
        __newTimeRangeArray__: null,
        strDate: '',
        endDate: ''
      }
      this.pageIndex_news = 1
      this.getLeftData()
    },
    // 每页数
    sizeChangeHandle_news (val) {
      this.pageSize_news = val
      this.pageIndex_news = 1
      this.handleSamePost()
    },
    // 当前页
    currentChangeHandle_news (val) {
      this.pageIndex_news = val
      this.handleSamePost()
    },
    checkNews () {
      if (this.checkedItem.length == 0) return this.$message.error('未勾选资讯！')
      if (this.checkedItem.length > 1) return this.$message.error('只能勾选一个资讯！')
      this.dataForm.title1 = this.checkedItem[0].title
      this.newsId = this.checkedItem[0].id
      this.dataForm.orgId = this.checkedItem[0].orgId
      this.dataForm.headImg = this.checkedItem[0].imgUrl
      this.addVisible = false
    },
    checkAll (val) {
      this.checkedItem = val
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    checktable () {
      this.handleSamePost()
      this.addVisible = true
    },
    validateTitle () {
      const title = this.dataForm.title1
      if (!title) {
        this.$message.error('标题不能为空')
        return false
      }
      if (title.length > 100) {
        this.$message.error('标题长度不能超过100个字符')
        return false
      }
      this.$message.success('输入有效')
      return true
    },
    openImgdailog () {
      this.openImg = true
      this.$nextTick(() => {
        this.$refs.upimg.init('pbRotary') //传入图片类型参数
      })
    },
    doneup (val, url) {
      this.dataForm.headImg = val
      this.imageUrl = url
    },
    //文件上传前的验证
    beforeAvatarUpload (file) {
      const isJPG =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    // 表单提交
    dataFormSubmit () {
      const data = {
        id: this.dataForm.id || '',
        type: this.dataForm.type,
        url: this.dataForm.url,
        title: this.dataForm.title1,
        orgId: this.dataForm.orgId,
        img: this.dataForm.headImg,
        newsId: this.newsId,
        miniAppId: this.dataForm.miniAppId,
        miniPath: this.dataForm.miniPath || 'pages/index/index'
      }

      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(
              `/pbRotary/${!this.dataForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: data
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                },
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    dalogClose () {
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.width_ct {
  width: 50%;
}

.sel_width_ct, .input_width_ct {
  width: 20% !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.dialog-footer {
  padding-bottom: 150px;
}

/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

.el-dialog-custom {
  overflow: hidden !important;
}

.el-dialog-custom /deep/ .el-dialog__body {
  padding: 20px;
  height: 70vh;
  overflow: auto;
}

.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}
</style>
